import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import className from 'classnames';
import axios from 'axios';

import {
  useModal,
} from '../hooks'

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import Modal from './Modal'
import ModeratorsListTable from './ModeratorsListTable'

const ModeratorsList = ({
  kentas = [],
  moderators = [],
}) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Kenta/Moderator users list</h2>
        </div>

        <div className='MainHeader__right'>
          <a
            className='MainHeader__right__a MainHeader__right__a--bright-blue'
            onClick={() => {
              modalSet(true)
            }}
          >
            Add new Kenta / Moderator
          </a>
        </div>
      </div>

      <div className='Moderators'>
        <div className='Moderators__col'>
          <h3 className='Moderators__h3'>Kenta users list <small>Total {get(kentas, 'length', 0).toLocaleString()} users</small></h3>

          <ModeratorsListTable
            data={kentas}
            type="kenta"
          />
        </div>

        <div className='Moderators__col'>
          <h3 className='Moderators__h3'>Moderator users list <small>Total {get(moderators, 'length', 0).toLocaleString()} users</small></h3>

          <ModeratorsListTable
            data={moderators}
            type="moderator"
          />
        </div>
      </div>

      <Modal
        isActive={modal}
        onToggleModal={() => {
          modalSet(false)
        }}
      >
        <div className='ModeratorsModal'>
          <h3 className='Modal__h3'>New Kenta / Moderator user</h3>

          <form
            className='ModeratorsModal__form'
            onSubmit={(e) => {
              e.preventDefault()
              const $els = e.target.elements
              const type = get($els, 'type.value')

              requestCallback(axios.post(`/${gon.currentProvider}/api/${type}s`, {
                data: {
                  user_id: get($els, 'userId.value').trim(),
                },
                authenticity_token: CSRF_TOKEN,
              }))
            }}
          >
            <input
              type='text'
              className='Input'
              name='userId'
              placeholder='User ID'
            />

            <div className='Radios'>
              <label>
                <input
                  type='radio'
                  name='type'
                  value='kenta'
                  defaultChecked
                />
                <span>Kenta</span>
              </label>

              <label>
                <input
                  type='radio'
                  name='type'
                  value='moderator'
                />
                <span>Moderator</span>
              </label>
            </div>

            <div className='ModeratorsModal__form__buttons'>
              <a
                className='Button Button--gray-light'
                onClick={() => {
                  modalSet(false)
                }}
              >
                Cancel
              </a>

              <button
                className='Button Button--blue'
              >
                Add
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  );
}

ModeratorsList.propTypes = {
};

export default ModeratorsList;
